import axios, { AxiosRequestConfig,AxiosResponse } from 'axios';

import { Helpers } from '~commonInfra/utils/Helpers';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { IDataConnectionAuthInfo } from '~src/datasource/dataConnection/serverApi/types/IDataConnectionAuthInfo';

import { ConnectionAuthenticationQueryParams, IAuthenticateDatabaseParams } from '../components/AuthenticateConnection';

export namespace AuthenticateDatabase {
    export const opener: any = window.opener;
    export function authenticate(path: string, data: IAuthenticateDatabaseParams): Promise<AxiosResponse<{}>> {
        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            url: path,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            data: Helpers.serialize(data)
        };
        return axios.request(requestConfig);
    }

    export function getAuthenticateDatabaseParams(
        queryParams: ConnectionAuthenticationQueryParams,
        authInfo: IDataConnectionAuthInfo,
        authenticationRememberPassword: boolean,
        selectedConnectionAuthMode: string,
        authenticationUsername: string,
        authenticationPassword: string
    ): IAuthenticateDatabaseParams {
        const reuse_forever = authenticationRememberPassword && authInfo.rememberPasswordsForever;
        const reuse = authenticationRememberPassword && !authInfo.rememberPasswordsForever;
        // W-23178201: send password plaintext over TLS; omit client-side RSA. RSA-1024/PKCS#1v1.5
        // caps input at ~117 bytes, so long Snowflake PATs produced an empty `crypted` and a
        // BadPassword loop. The RSA key is fetched over the same TLS channel, so RSA adds nothing
        // over HTTPS; the HTTP case is covered by the insecure-context warning. Matches W-19373381.
        const authParams: IAuthenticateDatabaseParams = {
            authentication: selectedConnectionAuthMode,
            username: authenticationUsername,
            password: authenticationPassword,
            connection: authInfo.connection,
            path: queryParams.path,
            oauthrequest: false, // BUGZID: 408070 Set oauthrequest to false for all non-OAuth scenarios
            reuse_forever,
            reuse,
        };
        return authParams;
    }

    export function signalAuthCompleted(): void {
        window.parent.postMessage('tableau.authCompleted', '*');
    }

    export function navigateTo(path: string): void {
        WindowLocationService.navigateTo(path);
    }

}
